module.exports = __webpack_public_path__ + "img/icon-ywqn-head-3.1126a281.png";